export default class Cookies {
  static get(cookieName) {
    var name = cookieName + '=';
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) === 0) {
        return temp.substring(name.length, temp.length);
      }
    }
    return '';
  }

  static getKeysByPattern(pattern) {
    const keys = [];
    const regex = new RegExp('^' + pattern);
    const allCookieArray = document.cookie.split('; ');
    for (let i = 0; i < allCookieArray.length; i++) {
      const key = allCookieArray[i].split('=')[0];
      if (regex.test(key) && !keys.includes(key)) {
        keys.push(key);
      }
    }
    return keys;
  }

  static getObjKeysByPattern(pattern) {
    const result = {};
    const regex = new RegExp('^' + pattern);
    const allCookieArray = document.cookie.split('; ');
    for (let i = 0; i < allCookieArray.length; i++) {
      const key = allCookieArray[i].split('=')[0];
      const value = allCookieArray[i].split('=')[1];
      if (regex.test(key) && !result[key]) {
        result[key] = value;
      }
    }
    return result;
  }

  static set(key, value, daysToExpire) {
    const date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + value + '; path=/; expires=' + date.toUTCString();
  }

  static unset(key) {
    document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
  }
}